export default function normalizeDate(dateInMS) {
    let date = new Date(dateInMS) ;
    if(date && !isNaN(date.getTime()))
        return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
    else 
        return "";
}
